export const MembershipTier = {
    free: 'free',
    essential: 'essential',
    core: 'core',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MembershipTier = (typeof MembershipTier)[keyof typeof MembershipTier];
